// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"0ccb705c","71":"1efe73a6","481":"004f6221","726":"c6b4a5a0","787":"fff96fce"}[chunkId] + ".chunk.js";
};